import moment from 'moment';

/**
 * Las fechas de viaje (departureDate / returnDate) son fechas de calendario,
 * no instantes: el día que elige el agente debe verse igual en cualquier zona
 * horaria (Tijuana UTC-7, CDMX UTC-6, Cancún UTC-5, etc.).
 *
 * Regla: se GUARDAN como mediodía UTC del día elegido y se MUESTRAN tomando
 * la parte de fecha en UTC, nunca convirtiendo a hora local. Antes se
 * guardaban a las 06:00 UTC (medianoche solo en UTC-6) o medianoche local,
 * lo que recorría la fecha un día para usuarios fuera de UTC-6.
 *
 * El servidor aplica la misma normalización como segundo candado
 * (normalizeTravelDates.js en la API y en Feathers).
 */

// Día elegido en el calendario (Date/moment local) -> mediodía UTC para guardar.
export const calendarDayToUtc = (date) =>
  moment.utc(moment(date).format('YYYY-MM-DD')).add(12, 'hours');

// Fecha guardada -> moment local a medianoche del MISMO día calendario,
// para resaltar el día correcto en el calendario (react-date-range).
export const utcToCalendarDay = (date) =>
  moment(moment.utc(date).format('YYYY-MM-DD'), 'YYYY-MM-DD');

// Fecha guardada -> texto para mostrar, usando la parte de fecha UTC.
export const formatTravelDate = (date, format = 'DD/MM/YYYY') =>
  moment.utc(date).format(format);



// WEBPACK FOOTER //
// ./src/libCustom/travelDates.js